import { LinkComponent } from './LinkComponent'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'
import { eCommerceMetadata, eventMetadata } from 'shared/store/metadata'
import type { Dispatch } from 'redux'

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    push,
    sendMeta: (meta: EventMetadata) => dispatch(eventMetadata(meta)),
    sendECommerceMeta: (meta: ECommerceMetadata) =>
        dispatch(eCommerceMetadata(meta))
})

const Link = connect(null, mapDispatchToProps)(LinkComponent)

export { Link }
